import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Globals } from '../models/globals.model';
import { FilterResponseModel } from '../models/filter/filter-response.model';

@Injectable({
  providedIn: 'root'
})

export class GlobalService {

  @Output() renderRibbon: EventEmitter<number> = new EventEmitter();  
  authCode: any;
  loggedInUser;
  subscription: string;
  environment: string;
  tagMovMsg;
  constructor( public httpClient: HttpClient
    , public dialog: MatDialog, public globals: Globals) { }

  hasTagAdminAccess(): boolean {
    return (this.globals.groups.includes('PlatformAdminGroupId') || this.globals.groups.includes('TagAdminGroupId'));
  }
  
  pipelineADFUrl = 'api/appsettings/section/PipelineDetailsUrl';
  isAuthorize: boolean = false;
  isActivate: boolean = true;
  modelListULR: string = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/models";
  deleteModelURL: string = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/models/";
  assetUrl = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/assets";
  registerModelURL = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/models";

  userDetails: any;
  firstTimeLoad: boolean = true;

  showAlert(model, data) {
     this.dialog.open(model, {
      width: '450px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
  }

  showAlertWithCallBack(model, data, methodRef: (thisRef: any, result?: any) => void, thisRef) {
    const dialogRef = this.dialog.open(model, {
      width: '450px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result != null) {
        methodRef(thisRef);
      }
    });
  }

  openModelWindow(methodRef: (thisRef: any, result?: any) => void, thisRef, modelComponent, widthOfWindow, panelClassName, dataToPass) {
    {
      const dialogRef = this.dialog.open(modelComponent, {
        width: widthOfWindow,
        disableClose: true,
        panelClass: panelClassName,
        data: dataToPass
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === true && methodRef != null) {
          methodRef(thisRef);
        }
        else if (result !== false) {
          methodRef(thisRef, result);
        }
       
      });
    }
  }

  /**
   * Loads small sized dialog box
   * @param methodRef
   * @param thisRef
   * @param modelComponent
   * @param data
   */
  openModelWindowSmall(methodRef: (thisRef: any, result?: any) => void, thisRef, modelComponent, data) {
    const dialogRef = this.dialog.open(modelComponent, {
      width: '450px',
      disableClose: true,
      panelClass: 'confirm-modalbox-dark',
      backdropClass: 'backdropBackground',
      height: 'auto',
      data: data
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      methodRef(thisRef, dialogResult);
    });
  }

  
  /**
   * Checks if the given string parameter is not undefined, null or empty.
   * @param data string to be checked
   */
  isNotNull(data: string) {
    let response: boolean = false;
    if (data != undefined && data != null && data != "") {
      response = true;
    }
    return response;
  }

  /**
   * Checks if the given object is not undefined or null.
   * @param data string to be checked
   */
  isNotNullObject(data) {
    let response: boolean = false;
    if (data != undefined && data != null) {
      response = true;
    }
    return response;
  }


  /**
   * Replaces display text for filter
   * @param tempText
   */
  replaceDisplayText(tempText: string) {
    switch(tempText) {
    case "tag": {
      return "Tag"; 
    } 
    case "locationName": {
      return "Location";
    } 
    case "descriptor": {
      return "Description";
    } 
    case "engUnits": {
      return "Engeering Unit";
    } 
    case "pointSource": {
      return "Point Source";
    } 
    case "pointType": {
      return "Point Type";
    } 
    case "pointTypeX": {
      return "Point Type X";
    } 
    case "dataSourceName": {
      return "Data Source";
    } 
    case "tagName": {
      return "Tag Name";
    } 
    case "cleansingRules": {
      return "Number of Rules";
    } 
    case "updatedBy": {
      return "Last Modified By";
    } 
    case "runBy": {
      return "Run By";
    } 
    case "runAt": {
      return "Run Time";
    } 
    case "status": {
      return "Last Status";
    } 
    case "name": {
      return "Pipeline Name";
    } 
    case "description": {
      return "Pipeline Description";
    } 
    case "folderName": {
      return "Folder Name";
    } 
    case "constantId": {
      return "Constant Name";
    } 
    case "value": {
      return "Value";
    } 
    case "uom": {
      return "UOM";
    } 
    case "lastModifiedBy": {
      return "Last Modified By";
    } 
    case "formulaId": {
      return "Formula Name";
    } 
    case "userExpression": {
      return "Expression";
    } 
    case "targetUom": {
      return "UOM";
    }
    default: {
      return tempText;
    }
  }
  }

  /**
   * Replace filter texts
   * @param tempText
   * @param application
   */
  replaceFilterText(tempText: string, application?: string): string {
    switch(tempText){
    case "Description": {
      return "descriptor";
    } 
    case "Run By": {
      return "runBy";
    } 
    case "Run Time": {
      return "runAt";
    } 
    case "Last Status": {
      return "status";
    } 
    case "Data Source": {
      return "dataSourceName";
    } 
    case "Tag Name": {
      return "tagName";
    } 
    case "Number of Rules": {
      return "cleansingRules";
    } 
    case "Last Modified By": {
      if (["constants", "formula"].includes(application)) {
        return "lastModifiedBy";
      } else {
        return "updatedBy";
      }
    } 
    case "Tag": {
      return "tag";
    } 
    case "Location": {
      return "locationName";
    } 
    case "Engeering Unit": {
      return "engUnits";
    } 
    case "Point Source": {
      return "pointSource";
    } 
    case "Point Type": {
      return "pointType";
    } 
    case "Point Type X": {
      return "pointTypeX";
    } 
    case "Pipeline Name": {
      return "name";
    } 
    case "Pipeline Description": {
      return "description";
    } 
    case "Folder Name": {
      return "folderName";
    } 
    case "Constant Name": {
      return "constantId";
    } 
    case "Value": {
      return "value";
    } 
    case "UOM": {
      if (application == "formula") {
        return "targetUom";
      } else if (application == "constants") {
        return "uom";
      }
      break;
    } 
    case "Formula Name": {
      return "formulaId";
    } 
    case "Expression": {
      return "userExpression";
    } 
    default: {
      return tempText;
    }
  }
  }

  /**
   * 
   * @param filterResponse
   * @param data
   */
  conditionalDataFiltering(filterResponse: FilterResponseModel, data) {
    let temp;
    if (filterResponse.selectedFieldName !== "cleansingRules") {
      switch(filterResponse.selectedValue.length) {
      case 1: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]);
        });
        break;
      } 
      case 2: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1]);
        });
        break;
      } 
      case 3: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]);
        });
        break;
      } 
      case 4: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[3]);
        });
        break;
      } 
      case 5: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[3])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[4]);
        });
        break;
      }
      default:{
        break;
      }
    }
    } else if (filterResponse.selectedFieldName == "cleansingRules") {
      switch(filterResponse.selectedCondition) {
      case "==": {
        temp = data.filter((df) => df[filterResponse.selectedFieldName].length === filterResponse.selectedValue[0] );
        break;
      } 
      case ">=": {
        temp = data.filter((df) => df[filterResponse.selectedFieldName].length >= parseInt(filterResponse.selectedValue[0], 10));
        break;
      } 
      case "<=": {
        temp = data.filter((df) => df[filterResponse.selectedFieldName].length <= parseInt(filterResponse.selectedValue[0], 10));
        break;
      }
      default:{
        break;
      }
    }
    }
    return temp;
  }

  /**
   * Filters data based on input text
   * @param filterValue
   * @param dataSource
   */
  applyFilter(filterValue: string, dataSource) {
    filterValue = filterValue.trim().toLowerCase(); // Remove whitespace and MatTableDataSource defaults to lowercase matches
    dataSource.filter = filterValue;
  }

  redirectTo(url) {
    window.location.href = url;
  }

}
